import { useRouter } from 'next/router';
import { pageParams } from '../config/page';
import { useProduct } from '../ProductProvider';
import { getProductDetail } from '@/service/ProductCommon/getProductDetail';

export default function getProductSpec() {
    const { state, dispatch } = useProduct();
    const { productMsg, productSpecs } = state;
    const { locale = 'us' } = useRouter();
    const { generalKeys, generalKeys_eu, generalKeys_jp, generalKeys_ph, generalKeys_nl } = pageParams;
    const IS_EU = ['eu', 'uk', 'de', 'fr', 'it', 'es'].includes(locale);
    const currentGeneralKeys =
        locale === 'nl' ? generalKeys_nl : locale === 'ph' ? generalKeys_ph : locale === 'jp' ? generalKeys_jp : IS_EU ? generalKeys_eu : generalKeys;

    const getData = async (generalKey: string) => {
        return await new Promise(async (resolve, reject) => {
            const product = productMsg && productMsg[generalKey];
            const res = await getProductDetail(product?.url, locale);
            if (res?.code === '0') {
                resolve({ productCatagory: res?.data?.productCatagoryResponseList, productDetail: res?.data?.spuResponse });
            } else {
                reject(res?.message);
            }
        });
    };

    if (productMsg && (!productSpecs || productSpecs?.length !== currentGeneralKeys.length)) {
        const promises: any[] = [];
        currentGeneralKeys.map((generalKey: string) => promises.push(getData(generalKey)));
        Promise.all(promises).then((payload: any) => {
            dispatch({
                type: 'changeProductSpec',
                payload,
            });
        });
    }

    return null;
}
